import { atom } from 'jotai';
export const paymentDrawerErrorAtom = atom(undefined);
export const paymentDrawerSuccessAtom = atom(undefined);
